import { createContext, useContext, useState } from 'react';

const userAuthContext = createContext();

export function UserAuthContextProvider({ children }) {
  const [user] = useState({});

  function logIn() {}
  function signUp() {}
  function logOut() {}
  function googleSignIn() {}
  function setUpRecaptha() {}

  return (
    <userAuthContext.Provider
      value={{
        user,
        logIn,
        signUp,
        logOut,
        googleSignIn,
        setUpRecaptha,
      }}
    >
      {children}
    </userAuthContext.Provider>
  );
}

export function useUserAuth() {
  return useContext(userAuthContext);
}
